var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44.913 26.682 H 15.231 c -8.28 0 -15.002 -3.611 -15.211 -11.841 C 0.016 14.972 0 15.099 0 15.231 v 31.303 c 8.265 10.233 20.908 16.784 35.087 16.784 h 0.682 c 8.28 0 12.002 3.611 12.211 11.841 c 0.003 -0.131 0.02 -0.258 0.02 -0.39 C 48 83.181 44.181 90 35.769 90 h 39 C 83.181 90 90 83.181 90 74.769 C 90 42.732 69.814 26.682 44.913 26.682 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,66,73, 70%)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 74.769 L 90 74.769 c 0 -24.901 -20.186 -45.087 -45.087 -45.087 H 15.231 c -8.28 0 -15.002 -6.611 -15.211 -14.841 C 0.016 14.972 0 15.099 0 15.231 C 0 6.819 6.819 0 15.231 0 h 59.538 C 83.181 0 90 6.819 90 15.231 V 74.769",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(70,78,87, 80%)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 74.769 V 43.534 c 8.265 10.233 20.908 16.784 35.087 16.784 h 0.682 c 8.28 0 15.002 6.611 15.211 14.841 c 0.003 -0.131 0.02 -0.258 0.02 -0.39 C 51 83.181 44.181 90 35.769 90 H 15.231 C 6.819 90 0 83.181 0 74.769 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(52,58,64, 70%)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.696 19.134 c 0 0 0.79 0.371 1.339 1.765 c 0 0 0.708 2.152 4.063 1.423 c 0.003 0.64 0.009 1.256 0.013 1.695 c 0.002 0.219 0.18 0.395 0.399 0.395 h 5.187 c 0.219 0 0.398 -0.176 0.399 -0.395 c 0.004 -0.618 0.011 -1.608 0.011 -2.758 c 0 -1.125 -0.385 -1.859 -0.818 -2.233 c 2.685 -0.299 5.507 -1.318 5.507 -5.95 c 0 -1.317 -0.468 -2.392 -1.241 -3.237 c 0.125 -0.304 0.538 -1.53 -0.118 -3.192 c 0 0 -1.011 -0.324 -3.313 1.236 c -0.964 -0.267 -1.996 -0.401 -3.021 -0.406 c -1.025 0.005 -2.056 0.139 -3.018 0.406 c -2.304 -1.56 -3.317 -1.236 -3.317 -1.236 C 9.113 8.306 9.526 9.533 9.651 9.836 c -0.771 0.845 -1.243 1.92 -1.243 3.237 c 0 4.621 2.816 5.655 5.495 5.96 c -0.345 0.301 -0.657 0.833 -0.766 1.613 c -0.688 0.308 -2.434 0.841 -3.509 -1.002 c 0 0 -0.638 -1.158 -1.849 -1.243 C 7.779 18.401 6.602 18.385 7.696 19.134 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255, 70%)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(2.81 0 0 2.81 1.4065934065934016 1.4065934065934016) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.b06cccc0444673cdef86875bfd15a075.svg";
export { ForwardRef as ReactComponent };